module.exports = __webpack_public_path__ + "img/photo-2.46777acb.jpg";